import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Typography,
    IconButton,
    Paper,
    Chip
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import UserComment from '../common/UserComment';

const useStyles = makeStyles((theme) => ({
    commentList: {
        marginBottom: theme.spacing(3),
    },
    commentItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        width: '100%',
        position: 'relative',
    },
    commentContent: {
        flexGrow: 1,
    },
    commentTools: {
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    editButton: {
        color: theme.palette.primary.main,
        padding: theme.spacing(0.5),
        fontSize: '1.2rem',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.dark,
            transform: 'scale(1.1)',
        },
        transition: 'all 0.2s ease-in-out',
    },
    deleteButton: {
        color: theme.palette.error.main,
        padding: theme.spacing(0.5),
        fontSize: '1.2rem',
        '&:hover': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.dark,
            transform: 'scale(1.1)',
        },
        transition: 'all 0.2s ease-in-out',
    },
    noComments: {
        textAlign: 'center',
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        fontSize: '1.6rem',
    },
    statusChip: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
        fontSize: '0.875rem',
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
}));

const ThreadCommentList = ({ currentUserId, threadOwnerId, onEdit, onDelete, commentList }) => {
    const classes = useStyles();

    const handleEditClick = (commentId, comment) => {
        onEdit(commentId, comment);
    }

    const handleDeleteClick = commentId => {
        onDelete(commentId);
    }

    return (
        <Box className={classes.commentList}>
            {commentList.length > 0 ? (
                commentList.map(comment => {
                    let mine = currentUserId === comment.user._id;
                    let commentStatus = threadOwnerId === comment.user._id ? '投稿者' : null;

                    return (
                        <Fragment key={comment._id}>
                            <Box className={classes.commentItem}>
                                <UserComment
                                    user={comment.user}
                                    comment={comment.comment}
                                    datetime={comment.created_at}
                                    status={commentStatus}
                                />
                            </Box>

                            {mine && (
                                <Box className={classes.commentTools}>
                                    <IconButton
                                        onClick={() => handleEditClick(comment._id, comment.comment)}
                                        className={classes.editButton}
                                        size="small"
                                        title="編集"
                                    >
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => handleDeleteClick(comment._id)}
                                        className={classes.deleteButton}
                                        size="small"
                                        title="削除"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            )}
                        </Fragment>
                    )
                })
            ) : (
                <Typography variant="h6" className={classes.noComments}>
                    まだコメントがありません
                </Typography>
            )}
        </Box>
    )
}

ThreadCommentList.propTypes = {
    commentList: PropTypes.array.isRequired,
    currentUserId: PropTypes.string,
    threadOwnerId: PropTypes.string,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
}

export default ThreadCommentList
